document.addEventListener('DOMContentLoaded',()=>{
  const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const animateNumber=(el)=>{
    if(el.dataset.animated==='true')return;
    el.dataset.animated='true';
    const target=parseInt(el.dataset.count||'0',10);
    const suffix=el.textContent.includes('€')?' €':'';
    if(reducedMotion){el.textContent=target.toLocaleString('fr-FR')+suffix;return;}
    const duration=1700;
    const start=performance.now();
    const ease=t=>1-Math.pow(1-t,4);
    const tick=now=>{
      const progress=Math.min(1,(now-start)/duration);
      const value=Math.round(target*ease(progress));
      el.textContent=value.toLocaleString('fr-FR')+suffix;
      if(progress<1)requestAnimationFrame(tick);
    };
    el.textContent='0'+suffix;
    requestAnimationFrame(tick);
  };

  const animateAmount=(el,delay=0)=>{
    if(el.dataset.amountAnimated==='true')return;
    el.dataset.amountAnimated='true';
    const original=el.textContent.trim();
    const match=original.match(/-?\d+(?:[.,]\d+)?/);
    if(!match)return;
    const raw=match[0];
    const target=parseFloat(raw.replace(',','.'));
    const decimals=(raw.split(/[.,]/)[1]||'').length;
    const prefix=original.slice(0,match.index);
    const suffix=original.slice((match.index||0)+raw.length);
    const format=value=>prefix+value.toLocaleString('fr-FR',{minimumFractionDigits:decimals,maximumFractionDigits:decimals})+suffix;
    if(reducedMotion){el.textContent=format(target);return;}
    window.setTimeout(()=>{
      const duration=1500;
      const start=performance.now();
      const ease=t=>1-Math.pow(1-t,4);
      const tick=now=>{
        const progress=Math.min(1,(now-start)/duration);
        el.textContent=format(target*ease(progress));
        if(progress<1)requestAnimationFrame(tick);
      };
      el.textContent=format(0);
      requestAnimationFrame(tick);
    },delay);
  };

  const show=(el)=>{
    el.classList.add('is-visible');
    if(el.matches('[data-pnd-reveal="counter"]')){
      el.querySelectorAll('.pnd-count').forEach(animateNumber);
    }
    if(el.matches('[data-pnd-reveal="costs"]')){
      el.querySelectorAll('.pnd-cost-item strong').forEach((amount,index)=>animateAmount(amount,420+(index*420)));
    }
  };

  const revealTargets=[...document.querySelectorAll('[data-pnd-logo-reveal],[data-pnd-title-reveal],[data-pnd-reveal]')];
  if(!('IntersectionObserver' in window)||reducedMotion){revealTargets.forEach(show)}
  else{
    const observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){show(entry.target);observer.unobserve(entry.target)}
      });
    },{threshold:.18,rootMargin:'0px 0px -8% 0px'});
    revealTargets.forEach(el=>observer.observe(el));
  }

  document.querySelectorAll('[data-pnd-gallery]').forEach(gallery=>{
    const main=gallery.querySelector('.pnd-main-product-image');
    const thumbs=gallery.querySelectorAll('[data-pnd-thumb]');
    if(!main||!thumbs.length)return;
    thumbs.forEach(btn=>btn.addEventListener('click',()=>{
      main.src=btn.dataset.full;main.srcset=btn.dataset.srcset||'';main.alt=btn.dataset.alt||main.alt;
      thumbs.forEach(b=>b.classList.remove('is-active'));btn.classList.add('is-active');
    }));
  });

  document.querySelectorAll('[data-pnd-product]').forEach(product=>{
    const select=product.querySelector('[data-pnd-variant-select]');
    const price=product.querySelector('[data-pnd-product-price]');
    const replenishmentMessage=product.querySelector('[data-pnd-replenishment-message]');
    const main=product.querySelector('.pnd-main-product-image');
    const thumbs=[...product.querySelectorAll('[data-pnd-thumb]')];
    if(!select)return;
    const applyVariant=()=>{
      const option=select.options[select.selectedIndex];if(!option)return;
      if(price&&option.dataset.price)price.textContent=option.dataset.price;
      if(replenishmentMessage)replenishmentMessage.hidden=option.dataset.replenishment!=='true';
      const imageId=option.dataset.imageId;
      const matchingThumb=imageId?thumbs.find(thumb=>thumb.dataset.imageId===imageId):null;
      if(matchingThumb)matchingThumb.click();
      else if(main&&option.dataset.image){main.src=option.dataset.image;main.srcset=option.dataset.srcset||'';main.alt=option.dataset.alt||main.alt;thumbs.forEach(t=>t.classList.remove('is-active'))}
      if(window.history&&window.history.replaceState){const url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url.toString())}
    };
    select.addEventListener('change',applyVariant);
  });

  // Profondeur très légère dans le hero (ordinateur uniquement).
  const hero=document.querySelector('.pnd-hero');
  if(hero&&!reducedMotion&&window.matchMedia('(hover:hover) and (pointer:fine)').matches){
    let raf=0;
    const update=(event)=>{
      const rect=hero.getBoundingClientRect();
      const x=((event.clientX-rect.left)/rect.width-.5)*5;
      const y=((event.clientY-rect.top)/Math.max(rect.height,1)-.5)*3;
      cancelAnimationFrame(raf);
      raf=requestAnimationFrame(()=>{
        hero.style.setProperty('--pnd-parallax-x',`${x.toFixed(2)}px`);
        hero.style.setProperty('--pnd-parallax-y',`${y.toFixed(2)}px`);
        hero.classList.add('is-pointer-active');
      });
    };
    hero.addEventListener('mousemove',update,{passive:true});
    hero.addEventListener('mouseleave',()=>{
      hero.style.setProperty('--pnd-parallax-x','0px');
      hero.style.setProperty('--pnd-parallax-y','0px');
      hero.classList.remove('is-pointer-active');
    });
  }

});
